import React from 'react'
type PlaceType = {
    place: String,
    desc: String
    img: String
}
const Place = ({place, img, desc }: PlaceType) => {
  return (
    <div className="place" style={{ background: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.4)), url(${img}) center center no-repeat`}}>
      <h2 className="heading-title">{place}</h2>
      <p>{desc}</p>
    </div>
  );
}

export default Place